import { useMutation, useQueryClient } from "@tanstack/react-query";
import homepageApi, { HOMEPAGE_KEY } from "../../api/homepageApi";

export const useCreateTextHomepage = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (description: string) => homepageApi.createText(description),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: HOMEPAGE_KEY });
        },
    });
};